import paayService from '@/services/paay-three-ds';
import cardinalService from '@/services/cardinal-three-ds';

/** Services are factory functions that expose submitTdsTransaction method */
const providerMap = {
  Paay: paayService,
  Cardinal: cardinalService
};

const _getTdsProviderService = providerName => providerMap[providerName] ?? null;

const getTdsProvider = (providers) => {
  const threeDsConfig = Object.values(providers)
    .map(provider => provider.threeDsConfig)
    .find(config => config?.threeDsRequired);

  const result = {
    tdsProviderService: _getTdsProviderService(threeDsConfig?.threeDsProvider),
    ...threeDsConfig
  };

  return result;
};

export default getTdsProvider;
